var _g, _mask, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEnglishIcon = function SvgEnglishIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#C4C4C4"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.73364 2.6748V8.29278L4.23926 6.04559C5.36285 4.24784 6.93589 3.12424 8.73364 2.6748Z",
    fill: "#04247B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.969 5.82087L15.4746 8.06806V2.6748C17.0476 3.12424 18.6207 4.24784 19.969 5.82087Z",
    fill: "#04247B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73364 15.9325V21.5505C6.93589 20.8763 5.36285 19.7527 4.23926 18.1797L8.73364 15.9325Z",
    fill: "#04247B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.969 18.1797C18.8454 19.7527 17.2724 20.8763 15.4746 21.5505V15.9325L19.969 18.1797Z",
    fill: "#04247B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.1124C22 12.7865 22 13.4607 21.7753 14.1348C21.7753 14.5843 21.5506 15.0337 21.3258 15.4831H18.6292L20.8764 16.6067C20.6517 17.0562 20.2022 17.7303 19.9775 18.1798L15.4831 15.9326V21.5506C14.809 21.5506 14.5843 21.7753 13.9101 21.7753C13.4607 22 12.7865 22 12.1124 22C11.4382 22 10.764 22 10.0899 21.7753C9.64045 21.7753 9.19101 21.5506 8.74157 21.3258V15.9326L4.24719 18.1798C4.02247 17.9551 3.79775 17.7303 3.79775 17.7303L8.29213 15.4831H5.37079L3.1236 16.6067C2.67416 15.7079 2.44944 14.809 2.22472 13.9101C2 13.4607 2 12.7865 2 12.1124C2 11.4382 2 10.764 2.22472 10.0899C2.22472 9.64045 2.44944 9.19101 2.67416 8.74157H5.37079L3.1236 7.61798C3.34831 6.94382 3.79775 6.26966 4.24719 5.82022L8.74157 8.06742V2.67416C9.19101 2.44944 9.64045 2.44944 10.0899 2.22472C10.764 2 11.4382 2 12.1124 2C12.7865 2 13.4607 2 14.1348 2.22472C14.5843 2.22472 15.0337 2.44944 15.4831 2.67416V8.29213L19.9775 6.04494L20.2022 6.26966L15.7079 8.51685H18.6292L20.8764 7.39326C21.3258 8.06742 21.5506 8.96629 21.7753 9.86517C22 10.764 22 11.4382 22 12.1124Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37632 8.74152H2.67969C2.90441 8.29208 2.90441 8.06736 3.12913 7.61792L5.37632 8.74152Z",
    fill: "#CE152A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5551 15.2577C21.3304 15.7071 21.1057 16.1566 20.881 16.606L18.6338 15.4824H21.5551V15.2577Z",
    fill: "#CE152A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8844 7.61688L18.6372 8.74048H15.7158L20.2102 6.49329C20.6596 6.71801 20.8844 7.16744 20.8844 7.61688Z",
    fill: "#CE152A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28768 15.2577L3.7933 17.5049C3.56858 17.2802 3.34386 16.8307 3.11914 16.3813L5.36633 15.2577H8.28768Z",
    fill: "#CE152A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.1124C22 12.7865 22 13.4607 21.7753 14.1348H13.9101V22C13.4607 22 12.7865 22 12.1124 22C11.4382 22 10.764 22 10.0899 21.7753V13.9101H2.22472C2 13.4607 2 12.7865 2 12.1124C2 11.4382 2 10.764 2.22472 10.0899H10.0899V2.22472C10.764 2 11.4382 2 12.1124 2C12.7865 2 13.4607 2 14.1348 2.22472V10.0899H22C22 10.764 22 11.4382 22 12.1124Z",
    fill: "#CE152A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnglishIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/english-icon.4c355c7c.svg";
export { ForwardRef as ReactComponent };